<template>
  <div :class="menuInactive ? 'container' : 'container container-offset'">
    <span class="buttons">
      <Button
        class="button-print p-button-rounded p-shadow-5"
        :style="{ width: '56px', height: '56px' }"
        @click="$emit('export')"
      >
        <IconPrint v-if="!loading" :width="45" :height="45"></IconPrint>
        <i v-else class="pi pi-spin pi-spinner" style="font-size: 25px"></i>
      </Button>
    </span>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import IconPrint from './icon/IconPrint';

export default {
  name: 'AppPrintButton',
  components: {
    IconPrint,
  },
  props: {
    loading: Boolean,
  },
  computed: {
    ...mapFields('app', ['menuInactive']),
  },
};
</script>

<style scoped>
.container {
  width: 56px;
  position: fixed;
  bottom: 1em;
  left: 1em;
  z-index: 2;
}

@media (min-width: 600px) {
  .container {
    left: 2em;
  }
}

.container-offset {
  left: 245px;
  transition: margin-left 0.2s;
  transition-property: margin-left;
  transition-duration: 0.2s;
  transition-timing-function: ease;
  transition-delay: 0s;
}

.button-print,
.button-print:hover {
  background-color: black !important;
  border-color: black !important;
}

.buttons {
  display: block;
  width: 35px;
  height: 35px;
  margin: 20px auto 0;
  position: relative;
  opacity: 0;
  transition: 0.2s;
}
.buttons:nth-last-of-type(1) {
  width: 56px;
  height: 56px;
  opacity: 1;
}
</style>
